import IdcardInput from './idcard-input.vue'
export type { IdcardInputProps } from './props'
export default IdcardInput